
import type * as ClassTypes from './types/class';
import {
    initAnimation,
    initCallbackPopup,
    initCarousel,
    initCarouselSlider,
    initContentSlider,
    initFirstScreenSlider,
    initHeader,
    initInfoPoint,
    initLoader,
    initPopup,
    initReviewsSlider,
    initSlider,
    initSliderMini,
    initSliderVertical,
    initStickySlider,
    initTabs,
    initTogglers
} from './common';
import type {IDynamicImport} from './types/utils';

// Анимация
initAnimation();

// Поведение шапки
const headerWrap = document.querySelector('.j-header') as HTMLElement;

if (headerWrap) {
    initHeader(headerWrap);
}

// Туглеры
const togglers = [...document.querySelectorAll('.j-toggle-wrapper')] as HTMLElement[];

togglers.forEach((elem: HTMLElement) => {
    initTogglers(elem);
});

// Carousel
const carousel = [...document.querySelectorAll('.j-carousel-wrapper')] as HTMLElement[];

carousel.forEach((wrapper: HTMLElement) => {
    initCarousel(wrapper);
});

// first-screen
const firstScreenSlider = [...document.querySelectorAll('.j-first-screen')] as HTMLElement[];

firstScreenSlider.forEach((wrapper: HTMLElement) => {
    initFirstScreenSlider(wrapper);
});

// Слайдер
const slider = [...document.querySelectorAll('.j-slider-wrapper')] as HTMLElement[];

slider.forEach((wrapper: HTMLElement) => {
    initSlider(wrapper);
});

// Слайдер
const contentSlider = [...document.querySelectorAll('.j-content-slider-wrapper')] as HTMLElement[];

contentSlider.forEach((wrapper: HTMLElement) => {
    initContentSlider(wrapper);
});

// Слайдер
const reviewsSlider = [...document.querySelectorAll('.j-reviews-slider-wrapper')] as HTMLElement[];

reviewsSlider.forEach((wrapper: HTMLElement) => {
    initReviewsSlider(wrapper);
});

// Слайдер
const carouselSlider = [...document.querySelectorAll('.j-carousel-slider-wrapper')] as HTMLElement[];

carouselSlider.forEach((wrapper: HTMLElement) => {
    initCarouselSlider(wrapper);
});

// Слайдер mini
const sliderMini = [...document.querySelectorAll('.j-slider-mini-wrapper')] as HTMLElement[];

sliderMini.forEach((wrapper: HTMLElement) => {
    initSliderMini(wrapper);
});

// Слайдер вертикальный
const sliderVertical = [...document.querySelectorAll('.j-slider-vertical-wrapper')] as HTMLElement[];

sliderVertical.forEach((wrapper: HTMLElement) => {
    initSliderVertical(wrapper);
});

// Sticky slider
const stickySliders = [...document.querySelectorAll('.j-slider-vertical-sticky')] as HTMLElement[];

stickySliders.forEach((wrapper: HTMLElement) => {
    initStickySlider(wrapper);
});

const sliderVerticalContent = [...document.querySelectorAll('.j-slider-vertical-content-wrapper')] as HTMLElement[];

sliderVerticalContent.forEach((wrapper: HTMLElement) => {
    initSliderVertical(wrapper);
});

// Табы
const tabs = [...document.querySelectorAll('.j-tabs-wrap')];

tabs.forEach((elem: Element) => {
    initTabs(elem as HTMLElement);
});

// Попапы
const popupSelectors = [...document.querySelectorAll('.j-popup')] as HTMLElement[];

if (popupSelectors.length) {
    initPopup(popupSelectors, {removeDelay: 300});
}

// Отдельный селектор для попапов обратных звонков
const popupFacadeLinks = [...document.querySelectorAll('.j-popup-callback:not([data-init])')] as HTMLElement[];

if (popupFacadeLinks.length) {
    initCallbackPopup(popupFacadeLinks);

    popupFacadeLinks.forEach((button: HTMLElement) => {
        button.dataset['init'] = 'true';
    });
}

// loader
const loader = document.querySelector('.j-loader') as HTMLElement;

if (loader) {
    initLoader(loader);
}

// карта в секции контактов
const contactsMap = document.querySelector('.j-contacts-map') as HTMLElement;

if (contactsMap) {
    import(/* webpackChunkName: "contacts-section" */ '@/sections/contacts')
        .then(({default: initContactsMap}: IDynamicImport) => {
            initContactsMap(contactsMap);
        });
}

// карта в секции location
const locationMap = document.querySelector('.j-location-map') as HTMLElement;

if (locationMap) {
    import(/* webpackChunkName: "location-map" */ '@/sections/location-map')
        .then(({default: initLocationMap}: IDynamicImport) => {
            initLocationMap(locationMap);
        });
}

const infoPoints = [...document.querySelectorAll<HTMLElement>('.j-info-point')];

infoPoints.forEach((point: HTMLElement) => {
    initInfoPoint(point);
});

// Ипотечный калькулятор
const mortgageCalculator = document.querySelector('.j-mortgage-calculator') as HTMLElement;

if (mortgageCalculator) {
    import(/* webpackChunkName: "mortgage-calculator" */ '@/components/mortgage-calculator')
        .then(({default: MortgageCalculator}: IDynamicImport) => {
            const calculator: ClassTypes.IMortgageCalculator = new MortgageCalculator(mortgageCalculator);

            calculator.init();

            // Отображения блока и подстановка месячного платежа ипотеки в карточке квартиры
            const priceMortgageWrappers = [...document.querySelectorAll('.j-price__mortgage')];
            const monthlyPayment = mortgageCalculator.dataset['minMonthly'];

            if (monthlyPayment?.length) {
                priceMortgageWrappers.forEach((wrapper: Element) => {
                    import(/* webpackChunkName: "price-monthly-payment" */ '@/components/price')
                        .then(({default: Price}: IDynamicImport) => {
                            const priceMonthlyPayment: ClassTypes.IPrice = new Price({
                                element: wrapper,
                                payment: monthlyPayment,
                                href   : mortgageCalculator.closest('section')?.id || null
                            });

                            priceMonthlyPayment.init();
                        });
                });
            }
        });
}

// Новости
const newsList = document.querySelector('.j-news') as HTMLElement;

if (newsList) {
    import(/* webpackChunkName: "news-list" */ '@/sections/news')
        .then(({default: NewsList}: IDynamicImport) => {
            new NewsList().init(newsList);
        });
}

// Уведомление об использовании cookies
const cookiesWrapper = document.querySelector('.j-cookies-notice') as HTMLElement;

if (cookiesWrapper) {
    import(/* webpackChunkName: "cookies-notice" */ '@/components/cookies-notice')
        .then(({default: CookiesNotice}: IDynamicImport) => {
            const cookiesNotice: ClassTypes.ICookiesNotice = new CookiesNotice();

            cookiesNotice.init(cookiesWrapper);
        });
}

// Новости
const progressList = document.querySelector('.j-progress') as HTMLElement;

if (progressList) {
    import(/* webpackChunkName: "progress-list" */ '@/sections/progress')
        .then(({default: ProgressList}: IDynamicImport) => {
            new ProgressList().init(progressList);
        });
}

// Простые анимации
const animationsBlocks = [...document.querySelectorAll('.j-animation-block')];

if (animationsBlocks.length) {
    if ('IntersectionObserver' in window) {
        const animationObserver = new IntersectionObserver((entries: IntersectionObserverEntry[]) => {
            entries.forEach((entry: IntersectionObserverEntry) => {
                if (entry.isIntersecting) {
                    if (!entry.target.classList.contains('is-active')) {
                        entry.target.classList.add('is-active');
                    }
                } else if (entry.target.classList.contains('is-active')) {
                    setTimeout(() => {
                        entry.target.classList.remove('is-active');
                    }, 500);
                }
            });
        });

        animationsBlocks.forEach((block: Element) => {
            animationObserver.observe(block);
        });
    } else {
        animationsBlocks.forEach((block: Element) => {
            block.classList.add('is-active');
        });
    }
}
